import { StoreAnalytics, trackStoreEvent } from '@nile/mantine-theme/analytics'

export type OffRampInterstitialType =
    | 'emergency'
    | 'urgent'
    | 'high_risk'
    | 'requires_triage'
    | 'unable_to_treat'
    | 'different_sku'

type RouteParams = Readonly<Record<string, string | string[] | undefined>>

const routeParam = (params: RouteParams, key: string): string | undefined => {
    const value = params[key]
    return typeof value === 'string' ? value : undefined
}

export const interstitialPayload = (
    offRampType: OffRampInterstitialType,
    skuId: string,
    routeParams: RouteParams,
) => {
    const payload = {
        off_ramp_type: offRampType,
        sku_id: routeParam(routeParams, 'sku-id') || skuId || undefined,
    }

    if (offRampType === 'different_sku') {
        return payload
    }

    return {
        ...payload,
        question_number: routeParam(routeParams, 'question-number'),
        questionnaire_id: routeParam(routeParams, 'questionnaireId'),
    }
}

export const trackQuestionnaireInterstitial = (
    offRampType: OffRampInterstitialType,
    skuId: string,
    routeParams: RouteParams,
) => {
    trackStoreEvent(StoreAnalytics.VIEWED_QUESTIONNAIRE_INTERSTITIAL, interstitialPayload(offRampType, skuId, routeParams))
}

export const trackServiceUnavailable = (skuId: string, skuCategory?: string) => {
    trackStoreEvent(StoreAnalytics.VIEWED_SERVICE_UNAVAILABLE, {
        sku_id: skuId,
        sku_category: skuCategory ?? 'other',
        source: 'questionnaire',
        off_ramp_type: 'econsult_unavailable',
    })
}

export const trackOffRampError = (skuId?: string) => {
    trackStoreEvent(StoreAnalytics.VIEWED_OFF_RAMP_ERROR, {
        sku_id: skuId || undefined,
    })
}
